import { render, staticRenderFns } from "./festivalDetail.vue?vue&type=template&id=22c552be&scoped=true&"
import script from "./festivalDetail.vue?vue&type=script&lang=js&"
export * from "./festivalDetail.vue?vue&type=script&lang=js&"
import style0 from "./festivalDetail.vue?vue&type=style&index=0&id=22c552be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c552be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22c552be')) {
      api.createRecord('22c552be', component.options)
    } else {
      api.reload('22c552be', component.options)
    }
    module.hot.accept("./festivalDetail.vue?vue&type=template&id=22c552be&scoped=true&", function () {
      api.rerender('22c552be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/tools/festivalDetail.vue"
export default component.exports